import { PenLine, Cpu, Rocket } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
    {
        number: "1",
        icon: PenLine,
        title: "Describe Your Idea",
        copy: "Tell Emergent what you want in plain, everyday words.",
        testId: "step-describe",
    },
    {
        number: "2",
        icon: Cpu,
        title: "AI Generates Your Project",
        copy: "Watch your website or app build itself in minutes.",
        testId: "step-generate",
    },
    {
        number: "3",
        icon: Rocket,
        title: "Customize & Launch",
        copy: "Tweak anything you like, then publish with one click.",
        testId: "step-launch",
    },
];

export const HowItWorks = () => (
    <section id="how-it-works" data-testid="how-it-works-section" className="px-6 py-20 sm:py-28">
        <div className="mx-auto max-w-6xl">
            <Reveal className="mb-12 text-center sm:mb-14">
                <Eyebrow>How it works</Eyebrow>
                <h2 className="mt-5 font-display text-4xl font-medium tracking-tight text-white sm:text-5xl">
                    Idea to live app in three steps.
                </h2>
            </Reveal>

            <Reveal>
                <div className="grid divide-y divide-white/10 overflow-hidden rounded-2xl border border-white/10 bg-[#0A0A0A] sm:grid-cols-3 sm:divide-x sm:divide-y-0">
                    {STEPS.map((step) => (
                        <div
                            key={step.number}
                            data-testid={step.testId}
                            className="group p-8 transition-colors duration-300 hover:bg-white/[0.03]"
                        >
                            <div className="flex items-center gap-3">
                                <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#8B5CF6]/40 bg-[#8B5CF6]/10 font-display text-sm font-medium text-[#8B5CF6]">
                                    {step.number}
                                </span>
                                <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 bg-white/5 text-white/60 transition-colors duration-300 group-hover:text-[#00C2FF]">
                                    <step.icon size={17} strokeWidth={1.5} />
                                </span>
                            </div>
                            <h3 className="mt-6 font-display text-xl font-medium text-white">{step.title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-white/55">{step.copy}</p>
                        </div>
                    ))}
                </div>
            </Reveal>
        </div>
    </section>
);
